import React, { Component } from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'

class ADForDableForm extends Component {

    componentDidMount() {
        const { onChange } = this.props
        onChange(
            Object.assign({},  this.props.data,{
                validated: false
            })
        )
    }

    @autobind
    handleADCodeChange(type, ADCode) {
        const { onChange } = this.props
        let newObject = Object();
        newObject[type] = ADCode;

        let validated = true;
        if( (ADCode.toLowerCase().indexOf("<script") === -1) || (ADCode.toLowerCase().indexOf("dable(") === -1) || (ADCode.toLowerCase().indexOf("</script>") === -1)) {
            validated = false;
        }

        onChange(
            Object.assign({},  this.props.data, {
                setting: Object.assign({},  this.props.data.setting, newObject),
                validated: validated
            })
        )
    }

    render() {
        const { plugin, data } = this.props;

        return (
            <div className="desc_plugin48">
                <p className="txt_plugin" dangerouslySetInnerHTML={{ __html: plugin.rawDescription }} />
                <div className="info_pluginline">
                    <strong className="tit_set">설정 방법</strong>
                    <ol className="list_plugin">
                        <li>
                            <span className="txt_em">1</span>
                            데이블에서 데이블 위젯 코드를 신청해 주세요. <a href="http://dable.io/ko/contact_media/" target="_blank" className="link_other">데이블 신청하기</a>
                        </li>
                        <li>
                            <span className="txt_em">2</span>
                            승인 후 발급받은 데이블 위젯 코드를 입력창에 넣어주세요.
                        </li>
                        <li>
                            <span className="txt_em">3</span>
                            적용 버튼을 누르면 설정이 완료됩니다.
                        </li>
                    </ol>
                </div>
                <fieldset>
                    <legend className="tit_set">광고 형태</legend>
                    <div className="list_preview">
                        <label className="lab_preview">
                            <span className="ico_dable ico_dable1">시크릿 위젯</span>
                            <textarea className="tf_blog" placeholder="시크릿 위젯은 스크롤을 200px 까지 내린 후 다시 올릴 시 나타납니다. 위젯의 가로 크기는 본문의 너비에 맞춰집니다."
                                      onChange={(e)=>this.handleADCodeChange('dableADCodeTop', e.target.value)}>{data.setting.dableADCodeTop}</textarea>
                        </label>
                        <label className="lab_preview">
                            <span className="ico_dable ico_dable2">하단 위젯</span>
                            <textarea className="tf_blog" placeholder="포스팅이 끝나는 지점에 위젯이 나타납니다. 위젯의 가로 크기는 본문 너비에 맞춰집니다."
                                      onChange={(e)=>this.handleADCodeChange('dableADCodeBottom', e.target.value)}>{data.setting.dableADCodeBottom}</textarea>
                        </label>
                        <label className="lab_preview">
                            <span className="ico_dable ico_dable3">사이드바 위젯</span>
                            <textarea className="tf_blog" placeholder="사이드바 영역에 적합한 위젯입니다. 위젯의 가로 크기는 사이드바의 너비에 맞춰집니다. 코드를 적용하신 후 꾸미기 - 사이드바에서 모듈 설정이 필요합니다."
                                      onChange={(e)=>this.handleADCodeChange('dableADCodeSidebar', e.target.value)}>{data.setting.dableADCodeSidebar}</textarea>
                        </label>
                    </div>
                </fieldset>
                {this.props.saveButton()}
            </div>
        )
    }
}

ADForDableForm.propTypes = {
    plugin: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
}

export default ADForDableForm
